<div class="property-wrapper">
	<div class="pre-wrapper" [ngSwitch]="config.ctype" [title]="!config.key ? '' : 'WIDGET_PROP_' + config.key.toUpperCase() | translate">

		<ng-container *ngSwitchCase="'pillbox'">
			<label 
				[for]="ind" 
				*ngIf="config.index !== '__adjunct__' && config.index !== '__radius__'"
                [attr.data-cy]="'pillbox-' + config.index"
				class="prop-index pillbox-index icon-center">{{config.index}}
			</label>
			<label 
				[for]="ind" 
				*ngIf="config.index === '__radius__'" 
				class="prop-index pillbox-index icon-center">
				<img src="/resources/img/border-radius-icon-a.svg"/>
			</label>
		</ng-container> 
	
		<ng-container *ngSwitchCase="'pillbox_animation'">
				<label 
					[for]="ind" 
					*ngIf="config.index !== '__alpha__'"
					class="prop-index pillbox-index icon-center">{{config.index}}
				</label>
				<label 
					[for]="ind" 
					*ngIf="config.index === '__alpha__'"
					class="prop-index pillbox-index icon-center">
					<i class="fa fa-adjust"></i>
				</label>
		</ng-container> 

		<ng-container *ngSwitchCase="'pillbox_color'">
			<label
				[for]="ind"
				*ngIf="config.index === '__color__'" 
				class="prop-index" 
				(click)="openColorDropdown()"
				[ngStyle]="{
					'background-color': color, 
					'border-color': color}">
				</label>
			<label
				[for]="ind"
				*ngIf="config.index === '__border__'" 
				class="prop-index" 
				(click)="openColorDropdown()"
				[ngStyle]="{
					'background-color': 'transparant', 
					'border-color': color, 
					'border-width': '2px'}">
				</label>
		</ng-container>

		<ng-container *ngSwitchCase="'pillbox_multi'">
			<label 
				[for]="ind" 
				class="prop-index pillbox-index icon-center">
				<i class="fa fa-indent"></i>
			</label>
		</ng-container>

		<ng-container *ngSwitchCase="'pillbox_mediaclip'">
			<ng-container [ngSwitch]="config.index">
				<label 
					*ngSwitchCase="'__font__'"
					(click)="openDropdown($event)"
					[for]="ind" 
					class="prop-index pillbox-index icon-center">
					<i class="fa fa-font"></i>
				</label>

				<label 
					*ngSwitchCase="'__image__'"
					(click)="openDropdown($event)"
					[for]="ind" 
					class="prop-index pillbox-index pillbox-index-img icon-center">
					<i class="fa fa-image"></i>
				</label>

				<label 
					*ngSwitchCase="'__media__'"
					(click)="openDropdown($event)"
					[for]="ind" 
					class="prop-index pillbox-index pillbox-index-img icon-center">
					<i class="fa fa-play-circle"></i>
				</label>

				<label 
					*ngSwitchCase="'__app__'"
					(click)="openDropdown($event)"
					[for]="ind" 
					class="prop-index pillbox-index pillbox-index-img icon-center">
					<i class="fa fa-object-group"></i>
				</label>

				<label 
					*ngSwitchDefault
					(click)="openDropdown($event)"
					[for]="ind" 
					class="prop-index pillbox-index icon-center pillbox-conditional">{{config.index}}
				</label>
			</ng-container>
		</ng-container>


	</div>

	<label [for]="ind" *ngIf="config.prefix" class="prop-prefix">{{config.prefix}}</label>

	<ng-container [ngSwitch]="config.ctype">

		<ng-container *ngSwitchCase="'pillbox'">
			<input 
				[id]="ind"
				type="text" 
				[placeholder]="config.value !== '__...__'? '' : '...'" 
				class="prop-value"
				[class.value-text]="!config.suffix"
				[class.has-adjunct]="config.index === '__adjunct__'"
				[formControl]="pillboxControl"
				[attr.disabled]="isDisabled || null"
				[size]="pillboxControl.value && pillboxControl.value !== 0? pillboxControl.value.length: 3"
				(change)="changeProperty(config.key, pillboxControl.value, $event)"
				(click)="$event.target.select()">
		</ng-container>

		<ng-container *ngSwitchCase="'pillbox_animation'">
			<input 
				[id]="ind"
				type="text" 
				class="prop-value"
				[ngStyle]="{'border-style' : 'solid none solid solid' }"
				[formControl]="pillboxControl"
				[size]="pillboxControl.value && pillboxControl.value.length !== 0 && pillboxControl.value.length < 5? pillboxControl.value.length: 5"
				(change)="changeProperty(config.key, pillboxControl.value, $event)"
				(click)="$event.target.select()">
		</ng-container>

		<ng-container *ngSwitchCase="'pillbox_color'">
			<input #originalEl
					maxlength="6"
					type="text"
					[placeholder]="config.value !== '__...__'? '' : '...'"
					class="prop-value value-color"
					[(value)]="origValue === '__...__'? '': origValue"
					(focus)="onOriginalFocus($event)"
					(click)="openColorDropdown()"
					(keydown.Tab)="closeColorPicker()"
					(keydown.shift.Tab)="closeColorPicker()"
					(change)="onOriginalChange(originalEl.value)"/>
			<input #shadowEl cdkOverlayOrigin #colorPicker="cdkOverlayOrigin" 
					type="text"
					disabled
					class="prop-hide"
					[(value)]="shadowValue"
					(click)="openColorDropdown()"
/> 
		</ng-container>

		<ng-container *ngSwitchCase="'pillbox_multi'">
			<input 
				[id]="ind"
				type="text" 
				[placeholder]="config.value !== '__...__'? '' : '...'" 
				class="prop-value"
				[(ngModel)]="pillboxControl.value === '__...__'? none : valueOutput" 
				[size]="pillboxControl.value && pillboxControl.value !== 0? valueOutput.length: 3"
				[formControl]="pillboxControl"
				#box 
				(change)="changeMulti(config.key, pillboxControl.value)"
				autocomplete="off"
				(click)="$event.target.select()"/>
		</ng-container>

		<ng-container *ngSwitchCase="'pillbox_mediaclip'" [ngSwitch]="config.index">
			<bb-select-6
				*ngSwitchCase="'__font__'" 
				[id]="ind" 
				[config]="config"
				(click)="openDropdown($event)"
				(onChangeOption)="changeDropdown($event)" 
				(onDropdownOpen)="dropdownOpened($event)"
				[filterConfig]="filterConfigFont">
			</bb-select-6>
			<bb-select-6 
				*ngSwitchCase="'__image__'"
				[id]="ind" 
				[config]="config" 
				(onChangeOption)="changeDropdown($event)" 
				(onDropdownOpen)="dropdownOpened($event)"
				[filterConfig]="filterConfigImage">
			</bb-select-6>
			<bb-select-6 
				*ngSwitchCase="'__media__'"
				[id]="ind" 
				[config]="config" 
				(onChangeOption)="changeDropdown($event)" 
				(onDropdownOpen)="dropdownOpened($event)"
				[filterConfig]="filterConfigMedia">
			</bb-select-6>
			<bb-select-6 
				*ngSwitchCase="'__app__'"
				[id]="ind" 
				[config]="config" 
				(onChangeOption)="changeDropdown($event)" 
				(onDropdownOpen)="dropdownOpened($event)"
				[filterConfig]="filterConfigApp">
			</bb-select-6>
			<bb-select-6 
				*ngSwitchDefault
				[id]="ind" 
				[config]="config" 
				(onChangeOption)="changeDropdown($event)" 
				(onDropdownOpen)="dropdownOpened($event)"
				[filterConfig]="filterConfigImage">
			</bb-select-6>
		</ng-container>

	</ng-container>

	<label [for]="ind" *ngIf="config.suffix" class="prop-suffix" [title]="!config.key ? '' : 'WIDGET_PROP_' + config.key.toUpperCase() | translate">{{config.suffix}}</label>
	
</div>